import React, { useCallback, useEffect } from "react";
import { StyledForgotPasswordForm } from "./index.styled";
import { Form, Input } from "antd";
import ContainerButton from "_lib/ContainerButton";
import { useCustomerManagementStore } from "_hooks";
import PropTypes from "prop-types";
import { MinimumPasswordLength } from "_constants";

const ForgotPasswordNewPasswordStep = (props) => {
  const { next, email } = props;

  const {
    customerManagement: { forgotPasswordResetStatus },
    forgotPasswordReset,
    clearForgotPasswordResetStatus,
  } = useCustomerManagementStore();

  useEffect(() => {
    if (forgotPasswordResetStatus === "success") {
      clearForgotPasswordResetStatus();
      next();
    }
  }, [clearForgotPasswordResetStatus, forgotPasswordResetStatus, next]);

  const onFinish = useCallback(
    (values) => {
      forgotPasswordReset({ email, newPassword: values?.newPassword });
    },
    [email, forgotPasswordReset]
  );

  const loading = forgotPasswordResetStatus === "loading";
  return (
    <StyledForgotPasswordForm layout="vertical" onFinish={onFinish}>
      <Form.Item
        name="newPassword"
        label="New Password"
        rules={[
          {
            min: MinimumPasswordLength,
            required: true,
            message: `Minimum password length is ${MinimumPasswordLength}`,
          },
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        name="confirm"
        label="Confirm Password"
        dependencies={["newPassword"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Please confirm your password!",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("newPassword") === value) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("The new password that you entered do not match!")
              );
            },
          }),
        ]}
      >
        <Input.Password />
      </Form.Item>

      <ContainerButton
        size="large"
        title="Send"
        type="primary"
        fullWidth
        htmlType="submit"
        loading={loading}
      />
    </StyledForgotPasswordForm>
  );
};

ForgotPasswordNewPasswordStep.propTypes = {
  next: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
};

export default ForgotPasswordNewPasswordStep;
